import { render } from "./RequiredStar.vue?vue&type=template&id=7b86eba8"
import script from "./RequiredStar.vue?vue&type=script&lang=js"
export * from "./RequiredStar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__